export default __webpack_public_path__ + "static/karriere-8d9d022ea4a3f085db95e569d1284636.svg";